<script>
  export let data;
  export let isMobile;
  export let even;
  export let year;
  export let referenceYears;
  export let current;
  export let minimapExpanded;

  import Icon from "./Icon.svelte";
</script>

<a
  class="year {current ? 'current' : 'not-current'}"
  class:isMobile
  href="#{year}"
>
  <div class="icons-container {even ? 'even' : 'odd'}">
    {#each data as d, index}
      <Icon data={d} iconHeight={isMobile ? 6 : 12} />
    {/each}
  </div>
  {#if minimapExpanded && referenceYears.includes(year)}
    <span class="reference-year">​​​  {year}</span>
  {/if}
</a>

<style>
  .year {
    margin-right: 2px;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    /* transition: background-color 1000ms linear; */
  }

  .current {
    background-color: #4571a8;
  }

  .not-current .icons-container {
    opacity: 0.35;
  }

  .icons-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .reference-year {
    position: absolute;
    bottom: -19px;
    font-size: 0.7rem;
    text-align: right;
    color: white;
  }

  .year.isMobile .reference-year {
    bottom: -16px;
    font-size: 0.6rem;
  }

  .reference-year::before {
    content: "|";
    position: absolute;
    left: 0px;
    top: -5px;
    font-size: 7px;
  }
</style>
